import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=6979e290&scoped=true"
import script from "./Inscription.vue?vue&type=script&lang=js"
export * from "./Inscription.vue?vue&type=script&lang=js"
import style0 from "./Inscription.vue?vue&type=style&index=0&id=6979e290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979e290",
  null
  
)

export default component.exports